import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ShoppingBag, Menu } from 'lucide-react';
import { useCart } from '../../lib/cart';
import { useLanguage } from '../../lib/i18n';
import { LanguageSelector } from '../ui/LanguageSelector';
interface MarketplaceHeaderProps {
  showPromo?: boolean;
}
export function MarketplaceHeader({
  showPromo = false
}: MarketplaceHeaderProps) {
  const {
    getItemCount,
    cart
  } = useCart();
  const {
    t
  } = useLanguage();
  const {
    slug: urlSlug
  } = useParams<{
    slug: string;
  }>();
  const itemCount = getItemCount();
  // Fallback to URL slug if cart doesn't have it (for legacy carts)
  const targetSlug = cart.restaurantSlug || urlSlug;
  return <header className="sticky top-0 z-40 w-full bg-[#0B0B0B] border-b border-white/10" data-id="element-1302">
      {/* Promo strip — only on marketplace/home */}
      {showPromo && <div className="bg-gradient-to-r from-emerald-600 via-emerald-500 to-emerald-600 text-white text-center py-1 sm:py-1.5 px-2 sm:px-4" data-id="element-1303">
          <Link to="/r/capricho-de-canela" className="text-[11px] sm:text-sm font-bold hover:underline block truncate" data-id="element-1304">
            🎉 Capricho de Canela: ¡2do producto a mitad de precio! →
          </Link>
        </div>}
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-1305">
        <div className="flex justify-between items-center h-12 sm:h-16" data-id="element-1306">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-id="element-1307">
            <div className="w-7 h-7 sm:w-8 sm:h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-1308">
              <span className="text-[#0B0B0B] font-bold text-base sm:text-lg leading-none" data-id="element-1309">
                N
              </span>
            </div>
            <span className="font-bold text-lg sm:text-xl tracking-tight text-white" data-id="element-1310">
              NOIZA
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-1311">
            <Link to="/" className="text-sm font-medium text-white/60 hover:text-[#C9A34E] transition-colors" data-id="element-1312">
              {t('home')}
            </Link>
            <Link to="/restaurants" className="text-sm font-medium text-white/60 hover:text-[#C9A34E] transition-colors" data-id="element-1313">
              {t('restaurants')}
            </Link>
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-2 sm:gap-4" data-id="element-1314">
            <LanguageSelector data-id="element-1315" />

            <Link to={targetSlug ? `/r/${targetSlug}/cart` : '/cart'} className="relative p-1.5 sm:p-2 text-white/60 hover:text-white transition-colors rounded-full" data-id="element-1316">
              <ShoppingBag className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-1317" />
              {itemCount > 0 && <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-[10px] sm:text-xs font-bold leading-none text-[#0B0B0B] transform translate-x-1/4 -translate-y-1/4 bg-[#C9A34E] rounded-full min-w-[18px] h-[18px] sm:min-w-[20px] sm:h-[20px]" data-id="element-1318">
                  {itemCount}
                </span>}
            </Link>

            <button className="md:hidden p-1.5 text-white/60 hover:text-white rounded-full" data-id="element-1319">
              <Menu className="w-5 h-5" data-id="element-1320" />
            </button>
          </div>
        </div>
      </div>
    </header>;
}